<template>
    <div class="col-sm-12 nopads mt-1 list-container">
        <div
            class="data-list-item add"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus"/>
            </div>
            <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
                <font-awesome-icon
                    icon="calendar-check"
                    class="card-body-icon"
                />
            </div>
        </div>

            <div v-if="results.length > 0" class="col-sm-12 pb-2 list-content result-table my-2">
                <vue3-datatable
                    :rows="results"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="85vh"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitEdit"
                >
                    <template #vehicle_types="row">
                        <div v-for="(type, index) in row.value.vehicle_types" v-bind:key="index" class="nopads">
                            {{ getVehicleTypeName(type.vehicle_type) }}
                        </div>
                    </template>
                    <template #color="row">
                        <div
                            class="nopads"
                            style="height: .7em; width: 0.7em; border-radius: 0.35em; border: solid #bcbcbc 1px; margin-left: 1em;"
                            :style="{ background: row.value.color}"
                        />
                    </template>
                    <template #tracking_mode="row">
                        {{ getTrackingModeName(row.value.tracking_mode)}}
                    </template>
                </vue3-datatable>
            </div>
    </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {vehicleHelper} from "@/components/mixins/VehicleMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'TasktypeList',
    mixins: [workManagementHelper, vehicleHelper],
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('orders.task_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle_types', title: this.$t('tasktypes.vehicle_types'), sort: false, headerClass: 'routa-table-header'},
                {field: 'tracking_mode', title: this.$t('tasktypes.tracking_mode'), sort: true, headerClass: 'routa-table-header'},
                {field: 'color', title: this.$t('tasktypes.color'), sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        },

        getTrackingModeName(mode) {
            switch (mode) {
                case 1: return this.$t('tasktypes.tracking_road')
                case 2: return this.$t('tasktypes.tracking_bicycle')
                case 3: return this.$t('tasktypes.tracking_sport')
                case 4: return this.$t('tasktypes.tracking_none')
            }
            return ''
        }
    }
}
</script>
